var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKindLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.66,
    height: 33,
    viewBox: "0 0 152.66 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_610c2f410fc987429d71941b_KL_logo",
    "data-name": "610c2f410fc987429d71941b_KL logo",
    transform: "translate(-39.997 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134865",
    "data-name": "Group 134865",
    transform: "translate(39.997 54.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95889",
    "data-name": "Path 95889",
    d: "M12.193,33.8,6.773,26.36l-2.023,2.1v5.345H.9V16.317H4.748v7.644l7.1-7.644H16.49l-7.12,7.42L16.815,33.8Z",
    transform: "translate(-0.9 -15.568)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95890",
    "data-name": "Path 95890",
    d: "M23.445,35.135V21.746h3.8V35.135Z",
    transform: "translate(-6.431 -16.9)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95891",
    "data-name": "Path 95891",
    d: "M60.655,33.562v-1.9a6,6,0,0,1-1.687,1.55,4.677,4.677,0,0,1-2.485.607,5.945,5.945,0,0,1-2.273-.45,5.6,5.6,0,0,1-1.949-1.337A6.639,6.639,0,0,1,50.9,29.855a7.976,7.976,0,0,1-.511-2.961v-.05a7.972,7.972,0,0,1,.511-2.96,6.793,6.793,0,0,1,1.349-2.175,5.508,5.508,0,0,1,1.936-1.336,6,6,0,0,1,2.3-.448,4.8,4.8,0,0,1,2.51.591,6.69,6.69,0,0,1,1.662,1.389v-6.58h3.8V33.562ZM60.7,26.84a4.254,4.254,0,0,0-.263-1.521,3.756,3.756,0,0,0-.7-1.182,3.1,3.1,0,0,0-3.546-.754,3.164,3.164,0,0,0-1.037.754,3.693,3.693,0,0,0-.712,1.17,4.219,4.219,0,0,0-.263,1.534v.05a4.255,4.255,0,0,0,.263,1.522,3.65,3.65,0,0,0,.712,1.182,3.143,3.143,0,0,0,1.037.754,3.056,3.056,0,0,0,3.546-.754,3.748,3.748,0,0,0,.7-1.182,4.255,4.255,0,0,0,.263-1.522Z",
    transform: "translate(-13.04 -15.325)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95892",
    "data-name": "Path 95892",
    d: "M40.365,35.052V27.6a3.005,3.005,0,0,0-.6-2.03,2.138,2.138,0,0,0-1.7-.688,2.253,2.253,0,0,0-1.736.686,2.885,2.885,0,0,0-.638,2.03v7.453H31.9V21.666h3.8v1.915a8.255,8.255,0,0,1,.712-.818,4.941,4.941,0,0,1,.862-.691,4.253,4.253,0,0,1,1.051-.479,4.422,4.422,0,0,1,1.3-.176,4.279,4.279,0,0,1,3.36,1.324,5.268,5.268,0,0,1,1.186,3.647v8.667Z",
    transform: "translate(-8.506 -16.817)",
    fill: "#004987"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1180",
    "data-name": "Ellipse 1180",
    cx: 2.232,
    cy: 2.232,
    r: 2.232,
    transform: "translate(56.688 53.802)",
    fill: "#68b1e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1181",
    "data-name": "Ellipse 1181",
    cx: 2.997,
    cy: 2.997,
    r: 2.997,
    transform: "translate(60.82 48.361)",
    fill: "#f26829"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1182",
    "data-name": "Ellipse 1182",
    cx: 4.1,
    cy: 4.1,
    r: 4.1,
    transform: "translate(51.94 44)",
    fill: "#e02826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95893",
    "data-name": "Path 95893",
    d: "M83.3,15.325H79.452V33.562H92.017V30.088H83.3Z",
    transform: "translate(19.826 39.391)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95894",
    "data-name": "Path 95894",
    d: "M108.78,23.625a5.89,5.89,0,0,0-2.035-1.612,6.526,6.526,0,0,0-2.9-.6,6.352,6.352,0,0,0-4.771,2.048,6.842,6.842,0,0,0-1.362,2.224,7.467,7.467,0,0,0-.487,2.7v.051a7.255,7.255,0,0,0,.525,2.81,6.609,6.609,0,0,0,1.461,2.186,6.448,6.448,0,0,0,2.223,1.423,7.625,7.625,0,0,0,2.787.5,7.11,7.11,0,0,0,3.172-.662,6.72,6.72,0,0,0,2.3-1.838l-2.175-1.921a5.793,5.793,0,0,1-1.549,1.051,4.229,4.229,0,0,1-1.7.324,3.4,3.4,0,0,1-2.137-.66A3.2,3.2,0,0,1,101,29.686h9.317c.016-.183.029-.342.038-.475s.013-.292.013-.475v-.05a9.609,9.609,0,0,0-.387-2.735A6.7,6.7,0,0,0,108.78,23.625Zm-7.829,3.684a3.883,3.883,0,0,1,.962-2.073,2.546,2.546,0,0,1,1.936-.774,2.488,2.488,0,0,1,1.923.788,3.7,3.7,0,0,1,.9,2.061Z",
    transform: "translate(15.466 37.898)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95895",
    "data-name": "Path 95895",
    d: "M146.339,21.9a6.688,6.688,0,0,0-1.661-1.389,4.8,4.8,0,0,0-2.511-.595,6.027,6.027,0,0,0-2.3.448,5.519,5.519,0,0,0-1.936,1.337,6.776,6.776,0,0,0-1.349,2.174,7.976,7.976,0,0,0-.512,2.961v.05a7.976,7.976,0,0,0,.512,2.961,6.638,6.638,0,0,0,1.362,2.173,5.607,5.607,0,0,0,1.948,1.337,5.948,5.948,0,0,0,2.273.45,4.666,4.666,0,0,0,2.486-.607,5.983,5.983,0,0,0,1.686-1.55v1.9h3.8V15.324h-3.8Zm.05,4.986a4.255,4.255,0,0,1-.263,1.522,3.777,3.777,0,0,1-.7,1.182,3.1,3.1,0,0,1-3.546.754,3.143,3.143,0,0,1-1.037-.754,3.644,3.644,0,0,1-.712-1.182,4.267,4.267,0,0,1-.263-1.522v-.05a4.233,4.233,0,0,1,.263-1.534,3.672,3.672,0,0,1,.712-1.17,3.156,3.156,0,0,1,1.037-.754,3.057,3.057,0,0,1,3.546.754,3.77,3.77,0,0,1,.7,1.182,4.257,4.257,0,0,1,.263,1.521Z",
    transform: "translate(5.936 39.392)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7764",
    "data-name": "Rectangle 7764",
    width: 3.797,
    height: 13.389,
    transform: "translate(158.256 59.563)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95896",
    "data-name": "Path 95896",
    d: "M173.763,21.411a4.422,4.422,0,0,0-1.3.177,4.268,4.268,0,0,0-1.051.479,4.963,4.963,0,0,0-.861.691,8.143,8.143,0,0,0-.712.817V21.664h-3.8V35.05h3.8V27.6a2.882,2.882,0,0,1,.638-2.03,2.253,2.253,0,0,1,1.735-.688,2.136,2.136,0,0,1,1.7.686,3,3,0,0,1,.6,2.03V35.05h3.8V26.383a5.267,5.267,0,0,0-1.186-3.647A4.28,4.28,0,0,0,173.763,21.411Z",
    transform: "translate(-1.417 37.901)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95897",
    "data-name": "Path 95897",
    d: "M194.814,21.667v1.749a7.368,7.368,0,0,0-1.773-1.424,5.065,5.065,0,0,0-2.548-.575,6.172,6.172,0,0,0-2.223.412,5.581,5.581,0,0,0-1.9,1.211A6,6,0,0,0,185.048,25a6.669,6.669,0,0,0-.5,2.661v.045a6.832,6.832,0,0,0,.487,2.661,5.847,5.847,0,0,0,1.313,1.961,5.553,5.553,0,0,0,1.9,1.211,6.215,6.215,0,0,0,2.248.413,5,5,0,0,0,2.523-.575,6.858,6.858,0,0,0,1.849-1.6v.65a3.665,3.665,0,0,1-.936,2.723,3.964,3.964,0,0,1-2.889.924,8.242,8.242,0,0,1-2.41-.328,11.256,11.256,0,0,1-2.111-.9l-1.3,2.846A11.841,11.841,0,0,0,188,38.739a13.35,13.35,0,0,0,3.147.362,11.97,11.97,0,0,0,3.273-.4,5.782,5.782,0,0,0,2.336-1.248,5.175,5.175,0,0,0,1.4-2.186,9.954,9.954,0,0,0,.46-3.234V21.667Zm.049,6.041a3.109,3.109,0,0,1-.249,1.248,2.985,2.985,0,0,1-.687.985,3.063,3.063,0,0,1-1.037.638,3.69,3.69,0,0,1-1.3.224,3.3,3.3,0,0,1-2.323-.85,2.906,2.906,0,0,1-.924-2.244v-.049a3.1,3.1,0,0,1,.249-1.248,2.965,2.965,0,0,1,.687-.985,3.073,3.073,0,0,1,1.024-.637,3.562,3.562,0,0,1,1.286-.224,3.673,3.673,0,0,1,1.3.224,3.073,3.073,0,0,1,1.037.637,2.986,2.986,0,0,1,.687.985,3.116,3.116,0,0,1,.249,1.248Z",
    transform: "translate(-5.957 37.897)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95898",
    "data-name": "Path 95898",
    d: "M159.416,14.113a2.232,2.232,0,1,0,2.232,2.232h0A2.232,2.232,0,0,0,159.416,14.113Z",
    transform: "translate(0.757 39.689)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95899",
    "data-name": "Path 95899",
    d: "M129.272,23.854l-5.463-2.464a1.758,1.758,0,0,0-.71,0l-5.462,2.464a.942.942,0,0,0-.569.854V35.041H120.6v-8.4l2.858-1.309,2.857,1.309v8.4h3.529V24.705a.94.94,0,0,0-.569-.852Z",
    transform: "translate(10.598 37.912)",
    fill: "#004987"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKindLogo);
export default __webpack_public_path__ + "static/media/kind_logo.1f3f9787f0e730c37085e0046c389241.svg";
export { ForwardRef as ReactComponent };